export default __webpack_public_path__ + "img/MYMY-circular-logo.svg";